var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirm',{attrs:{"title":"お問合せ受付完了 ","description":"お問合せ内容確認後、ご入力頂いたメールアドレス宛にご連絡致します。","buttonText":"トップページに戻る","to":"dashboard"}})}
var staticRenderFns = []

export { render, staticRenderFns }